import { useCallback, useLayoutEffect, useRef } from "react";
import { useDispatch } from "react-redux";

export function useReportFetchController() {
  const controllerRef = useRef(null);

  const abortPending = useCallback(() => {
    if (controllerRef.current) {
      controllerRef.current.abort();
      controllerRef.current = null;
    }
  }, []);

  const createController = useCallback(() => {
    abortPending();
    const controller = new AbortController();
    controllerRef.current = controller;
    return controller;
  }, [abortPending]);

  return { abortPending, createController };
}

export default function useReportMountReset(
  clearAction,
  onResetLocalState,
  { onAbort } = {}
) {
  const dispatch = useDispatch();
  const onResetRef = useRef(onResetLocalState);
  onResetRef.current = onResetLocalState;
  const onAbortRef = useRef(onAbort);
  onAbortRef.current = onAbort;

  useLayoutEffect(() => {
    onAbortRef.current?.();
    dispatch(clearAction());
    onResetRef.current?.();

    return () => {
      onAbortRef.current?.();
      dispatch(clearAction());
    };
  }, [dispatch, clearAction]);
}

export const resetPaginationState = (setPagination) => {
  if (typeof setPagination !== "function") return;
  setPagination((prev) => ({
    ...prev,
    current: 0,
    isLastPage: false,
    totalPages: 0,
    totalItems: 0,
  }));
};
